<template>
  <div class="visitor">
    <el-date-picker
      :clearable="false"
      v-model="releaseDate"
      type="date"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      @change="changeReleaseDate"
      placeholder="请选择时间"
      style="width: 150px; margin: 10px 0 20px 0"
    />
    <div class="statistics">
      <div class="statistics-item left">
        <div class="statistics-title">数据看板</div>
        <div class="statistics-body">
          <div v-for="item in boardData.left" :key="item.id" class="body-item">
            <div class="count">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="statistics-item right">
        <div class="statistics-title">累计数据</div>
        <div class="statistics-body">
          <div v-for="item in boardData.right" :key="item.id" class="body-item">
            <div class="count">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="handle">
        <div class="search_wrapper">
          <el-form :inline="true">
            <el-form-item label="今日值班门卫：" v-if="activeName == 1">
              <el-select
                v-model="useName"
                placeholder="请选择"
                clearable
                style="width: 160px"
                 @change="changeUserName"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.nickname + '/' + item.phone + '/' + item.id"
                  :label="item.nickname"
                  :value="item.nickname + '/' + item.phone + '/' + item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane label="待放行" name="1"></el-tab-pane>
          <el-tab-pane label="已放行" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="table-container">
        <el-table
          :data="tableList"
          v-loading="tableLoading"
          :height="windowHeight"
          :key="activeName"
          :span-method="objectSpanMethod"
          border
        >
          <el-table-column label="车牌号码" width="213" align="center">
            <template slot-scope="{ row }">
              <div class="state_content">
                <div
                  v-if="activeName == 1"
                  class="state"
                  :class="
                    row.processStatus == 5
                      ? 'state3'
                      : row.approvalStatusName == '审核通过' ||
                        row.approvalStatusName == '已审核'
                      ? 'state1'
                      : row.approvalStatusName == '审核中' ||
                        row.approvalStatusName == '装货中'
                      ? 'state2'
                      : ''
                  "
                >
                  {{
                    row.processStatus == 5 ? "已超时" : row.approvalStatusName
                  }}
                </div>
                <div v-if="activeName == 2" class="state state2">已放行</div>
                <div
                  v-if="row.carNumber"
                  @click="checkDetail(row)"
                  style="color: #048afb"
                >
                  {{ row.carNumber }}
                </div>
                <div v-else @click="checkDetail(row)" style="color: #048afb">
                  --
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="driverName" width="120" />
          <el-table-column label="物品" prop="goodsName" width="120" />
          <el-table-column label="数量" prop="goodsNumber" width="120" />

          <el-table-column
            label="自带货物信息"
            prop="productName"
            width="130"
          />
          <el-table-column label="备注" prop="phone" />
          <el-table-column
            label="操作"
            width="180"
            fixed="right"
            align="center"
          >
            <!--  -->
            <template slot-scope="{ row }">
              <div class="operate_btn">
                <div
                  v-if="activeName == 2"
                  style="color: #048afb"
                  @click="checkDetail(row)"
                >
                  详情
                </div>
                <!-- <el-popconfirm
                  title="您是否确定通过放行"
                  @confirm="confirmRelease(row)"
                 
                >
                  
                </el-popconfirm> -->
                <div
                  class="btn green"
                  v-if="activeName == 1 && row.processStatus != 5"
                  @click="releasePass(row)"
                >
                  通过
                </div>
                <div
                  class="btn err"
                  @click="chandleFefuse(row)"
                  v-if="activeName == 1 && row.processStatus != 5"
                >
                  拒绝
                </div>

                <!-- <el-popconfirm
                  title="您是否确定提醒重开"
                  @confirm="confirmReopen(row)"
                  v-if="activeName == 1 && row.processStatus == 5"
                >
               
                </el-popconfirm> -->
                <div
                  class="btn yellow"
                  v-if="activeName == 1 && row.processStatus == 5"
                  @click="handleReopen(row)"
                >
                  提醒重开
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-pagination
          :current-page="pageData.page"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <el-dialog :visible.sync="visibleRefuse" width="50%">
      <div class="visibleRefuse">
        <div class="title">拒绝放行</div>
        <div class="content">
          <div class="top">
            <div class="left">值班门卫：{{ this.refuseUser[0] }}</div>
            <div class="left">电话：{{ this.refuseUser[1] }}</div>
          </div>
          <div class="center">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model.trim="remark"
            >
            </el-input>
          </div>
          <div class="bottom">
            <div
              class="bottom_item"
              v-for="(item, index) in remarksList"
              :key="index"
              @click="handleRemarks(item)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="footer">
          <el-button class="cancel" @click="cancelRefuse">取消</el-button>
          <el-button class="submit" @click="submitRefuse">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="放行通过" :visible.sync="passVisible" width="30%">
      <span>您是否确定通过放行?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRelease">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提醒重开" :visible.sync="reopenVisible" width="30%">
      <span>您是否确定通过放行?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reopenVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmReopen">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis";
import moment from "moment";
export default {
  name: "dormManage",
  data() {
    return {
      tableLoading: false,
      btnLoading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },
      value: "",
      options: {
        parkList: [],
        typeList: []
      },
      model: {},
      total: 0,
      boardData: {
        left: [],
        right: []
      },
      tableList: [],
      activeName: "1",
      useName: "",
      windowHeight: 350,
      visibleRefuse: false,
      userList: [],
      remark: "",
      remarksList: [],
      refuseUser: [],
      itemId: "",
      releaseDate: moment(new Date()).format("YYYY-MM-DD"),
      passVisible: false,
      itemRow: {},
      reopenVisible: false
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    },
    value: function () {
      this.pageData.page = 1;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryStatistics();
    this.parkUserList();
    this.getData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 410;
      });
    },
    // tabs切换
    tabClick() {
      this.getData();
    },
    // 放行时间切换
    changeReleaseDate() {
      this.queryStatistics();
      this.getData();
    },
    //统计
    queryStatistics() {
      const idInfo = JSON.parse(sessionStorage.getItem("visitorUserName"));
      const json = {
        releaseDate: this.releaseDate,
        type: 2,
        releaseType: 4,
        parkIdStr: idInfo.parkIds
      };
      apis.queryStatistics(json).then(res => {
        if (res.code == 200) {
          this.boardData.left = [
            {
              label: "待放行人员",
              num: res.data.visiting
            },
            {
              label: "已放行人员",
              num: res.data.pending
            },
            {
              label: "已放行车辆",
              num: res.data.leaveReleased
            }
          ];
          this.boardData.right = [
            {
              label: "累计放行人员",
              num: res.data.generalAdd
            },
            {
              label: "累计放行车辆",
              num: res.data.releasedAdd
            }
          ];
        }
      });
    },
    // 分页
    sizeChange(value) {
      this.pageData.pageSize = value;
      this.getData();
    },
    // 分页
    currChange(value) {
      this.pageData.page = value;
      this.getData();
    },
    // 数据列表
    getData() {
      this.tableLoading = true;
      const idInfo = JSON.parse(sessionStorage.getItem("visitorUserName"));
      apis
        .queryByPageReleaseList({
          ...this.pageData,
          ...this.model,
          type: this.activeName == 1 ? 1 : 2,
          releaseType: 4,
          releaseDate: this.releaseDate,
          parkIdStr: idInfo.parkIds
        })
        .then(res => {
          this.tableList = res.data.list;
          this.total = res.data.total;
          this.tableLoading = false;
        })
        .finally(() => (this.tableLoading = false));
    },
    //查看详情
    checkDetail(row) {
      this.$router.push({
        path: "/visitor/carReleaseDetail",
        query: {
          id: row.id
        }
      });
    },
    releasePass(row) {
      if (this.useName) {
        this.itemRow = row;
        this.passVisible = true;
      } else {
        this.$message({
          message: "请选择今日值班门卫",
          type: "warning"
        });
      }
    },
    // 通过放行
    confirmRelease() {
      // if (this.useName) {
      // const idInfo = JSON.parse(sessionStorage.getItem("visitorUserName"));
      const idInfo = this.useName.split("/");
      console.log(1111000, this.refuseUser);
      const json = {
        ids: [this.itemRow.id],
        releaseStatus: 2,
        userId: idInfo[2]
      };
      apis.updateStatusRelease(json).then(() => {
        this.$message.success("放行成功!");
        this.queryStatistics();
        this.getData();
        this.passVisible = false;
      });
      // } else {
      //   this.$message({
      //     message: "请选择今日值班门卫",
      //     type: "warning"
      //   });
      // }
    },
    handleReopen(row) {
      this.itemRow = row;
      this.reopenVisible = true;
    },
    // 提醒重开
    confirmReopen(row) {
      console.log("提醒重开");
      const json = {
        id: row.id
      };
      apis.remindReopen(json).then(() => {
        this.$message.success("重开成功!");
        this.queryStatistics();
        this.getData();
        this.reopenVisible = false;
      });
    },
    // 拒绝
    chandleFefuse(row) {
      if (this.useName) {
        this.queryRemarkList();
        this.refuseUser = this.useName.split("/");
        this.remark = "";
        this.visibleRefuse = true;
      } else {
        this.$message({
          message: "请选择进入值班门卫",
          type: "warning"
        });
      }
      this.itemId = row.id;
    },
    //取消拒绝
    cancelRefuse() {
      this.visibleRefuse = false;
    },
    //确认拒绝
    submitRefuse() {
      this.visibleRefuse = false;
      const json = {
        remark: this.remark,
        ids: [this.itemId], //管理员 使用当前登录人，保安使用保安的
        releaseStatus: 3,
        userId: this.refuseUser[2]
      };
      apis.updateStatusRelease(json).then(() => {
        this.$message.success("拒绝成功!");
        this.queryStatistics();
        this.getData();
      });
    },
    // 备注操作
    handleRemarks(item) {
      if (this.remark.includes(item)) {
        // 如果包含，则从结果中移除当前项目
        this.remark = this.remark.replace(item, "").trim();
      } else {
        // 如果不包含，则将当前项目添加到结果中
        this.remark += item + " ";
      }
    },
    // 门卫列表
    parkUserList() {
      const info = JSON.parse(sessionStorage.getItem("visitorUserName"));
      apis
        .querySecurityList({
          parkIds: info.parkIds
        })
        .then(({ data }) => {
          this.userList = data;
          this.useName=localStorage.getItem('doorkeeperUserName')
        });
    },
    // 备注列表
    queryRemarkList() {
      apis.queryRemarkList().then(res => {
        if (res.code == 200) {
          console.log(222, res);
          this.remarksList = res.data;
        }
      });
    },
    // 表格合并
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 6) {
        // 只处理第一列
        let currentSpan = 1; // 当前行需要合并的行数
        let nextRowIndex = rowIndex + 1; // 下一行的索引

        // 检查下一行是否存在且 'zoneNew' 值相同
        while (
          this.tableList[nextRowIndex] &&
          this.tableList[nextRowIndex].releaseNumber === row.releaseNumber
        ) {
          currentSpan++;
          nextRowIndex++;
        }

        // 如果当前行不是合并的起始行，则隐藏该单元格
        if (
          rowIndex !== 0 &&
          this.tableList[rowIndex - 1].releaseNumber === row.releaseNumber
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }

        // 返回合并信息
        return {
          rowspan: currentSpan,
          colspan: 1
        };
      }
    },
    changeUserName(value) {
      localStorage.setItem('doorkeeperUserName',value)
    }
  }
};
</script>
<style lang="scss">
.el-popconfirm__action {
  margin-top: 10px;
  .el-button {
    padding: 4px 12px;
  }
}
</style>
<style lang="scss" scoped>
.visitor {
  height: calc(100vh - 77px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
  .green {
    color: #388654;
  }
  .red {
    color: #e46d6e;
  }
  .yeallow {
    color: #ff8f25;
  }
}
.statistics {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .statistics-item {
    padding: 0 30px 0 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #d8d8d8;

    &.left,
    &.right {
      width: 49%;
    }
  }

  .statistics-title {
    font-size: 10px;
    font-weight: 400;
    color: #000;
    line-height: 25px;
    border-bottom: 1px solid #d8d8d8;
  }

  .statistics-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px 5px;
  }

  .body-item {
    flex: 1;
  }

  .count {
    font-size: 12px;
    font-weight: 500;
    color: #008755;
    text-align: center;
  }
  .label {
    font-size: 8px;
    font-weight: 400;
    color: #3d3d3d;
    line-height: 15px;
    text-align: center;
  }
}
.filter {
}
.handle {
  width: 100%;
  position: relative;
  margin-top: 30px;
  .search_wrapper {
    position: absolute;
    right: 0;
    top: 0px;
    z-index: 1;
  }
  ::v-deep {
    .el-tabs__item.is-active {
      color: #388654;
    }
    .el-tabs__active-bar {
      height: 4.5px;
      top: 24px;
      background: #388654;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
}
.table-container {
  margin-bottom: 10px;
  .state_content {
    display: flex;
    align-content: center;
    .state {
      font-size: 9px;
      padding: 0 2px;
      margin-right: 15px;
      flex-shrink: 0;
      height: 16px;
      border-radius: 3px;
    }
    .state1 {
      background: rgba(56, 134, 84, 0.1);
      color: #388654;
    }
    .state2 {
      background: rgba(4, 138, 251, 0.1);
      color: #048afb;
    }
    .state3 {
      background: rgba(226, 33, 33, 0.1);
      color: #e22121;
    }
  }
  .operate_btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    .btn {
      padding: 0px 10px;
      border-radius: 10px;
      height: 18px;
      margin-bottom: 5px;
    }
    .err {
      border: 1px solid #e22121;
      color: #e22121;
    }
    .green {
      border: 1px solid #388654;
      color: #388654;
    }
    .yellow {
      border: 1px solid #ff8f25;
      color: #ff8f25;
    }
  }
}
.unconfirmed {
  color: #d02727;
}
.affirm {
  color: #018755;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}
.success,
.fail {
  display: none;
}

.peo-title {
  padding-left: 40%;
  font-size: 16px;
}

.addPeople {
  // position: absolute;
  // top: 45px;
  // right: 20px;
  float: right;
}

.add-button {
  ::v-deep .el-input {
    float: left;
    width: 280px;
  }
  ::v-deep .el-button {
    float: right;
  }
}
// ::v-deep .el-notification{
//   width: 450px !important;
//   height: 200px !important;
// }

.table-peo {
  ::v-deep .cell {
    font-size: 14px !important;
    line-height: 30px !important;
  }
}

::v-deep {
  .cell {
    font-size: 10px;
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
}
.visibleRefuse {
  .title {
    line-height: 11px;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 11px;
    color: #18191e;
    margin-left: 5px;
    margin-top: -30px;
    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 11px;
      background: #388654;
      margin-right: 5px;
    }
  }
  .content {
    padding: 20px 10px 0 10px;
    .top {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .left {
        margin-right: 30px;
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      margin-top: 10px;
      flex-wrap: wrap;
      .bottom_item {
        background: rgba(56, 134, 84, 0.1);
        border-radius: 4px;
        margin-right: 10px;
        padding: 2px 6px;
        font-size: 10px;
        color: #388654;
        flex-shrink: 0;
        margin-bottom: 5px;
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    .cancel {
      border: 1px solid #388654;
      color: #388654;
    }
    .submit {
      background: #388654;
      color: #fff;
    }
  }
}
</style>
